// extracted by mini-css-extract-plugin
export var divider = "_qx-0";
export var systemMessage = "_qx-1";